/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'

import Menu from '../../../../components/InternalMenu/Menu'

import Switch from "react-switch"

import { get, put } from '../../../../services/http'
import { notify } from '../../../../components/Toast'

import { ToastContainer } from 'react-toastify'
import { useNavigate } from 'react-router-dom'

import { useParams } from 'react-router'

export default function index() {
  const navigate = useNavigate()
  const { id } = useParams()

  const [name, setName] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [reserveData, setReserveData] = useState('')
  const [tableNumber, setTableNumber] = useState('')
  const [reserveStatus, setReserveStatus] = useState('')

  const token = localStorage.getItem('token')
  
  document.title = 'جزئیات استخدام'

  useEffect(() => {
    get(`/api/admin/im/reservation/${id}?token=${token}`)
      .then(response => {
        setName(response.data.data[0].name)
        setPhoneNumber(response.data.data[0].phoneNumber)
        setReserveData(response.data.data[0].reserveDate)
        setTableNumber(response.data.data[0].tableNumber)
        setReserveStatus(response.data.data[0].status)
      }).catch(error => {
        console.log(error)
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }, [id, token])

  const statusHandler = () => {
    let data = { status: true }
    setReserveStatus(!reserveStatus)
    if (reserveStatus) {
      data = { status: false }
    } else {
      data = { status: true }
    }
    put(`/api/admin/im/reservation/status/${id}?token=${token}`, data)
      .then(response => {
        notify('success', response.data.messageFa)
        setTimeout(() => {
          navigate('/im/reservation')
        }, 2000)
      })
      .catch(error => {
        if (error) {
          notify('error', error)
        }
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'reservation'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className='right' style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
              <div className='text' >
                <div>
                </div>
                <Switch onChange={statusHandler} 
                  checked={reserveStatus ? reserveStatus : false} 
                  onColor="#86d3ff"
                  onHandleColor="#2693e6"
                  handleDiameter={30}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={20}
                  width={48}
                  className="react-switch"
                  id="material-switch"
                  />
              </div>
              <div>
              </div>
            </div>

            <div className='left'>
            </div>
          </div>

          <form className='form'>
            <div className='title'>
              * با سوئیچ بالا میتوانید بررسی شدن یا نشدن آنرا مشخص کنید.
            </div>
            <div className='lineTitleFood'>
              <hr />
              اطلاعات فرد
              <hr />
            </div>
            <div className='row'>
              <div className='textarea'>
                <label htmlFor='foodName'>مشخصات :</label>
                <ul className='list'>
                  <li>نام و نام خانوادگی : {name ? name : ''}</li>
                  <li>شماره موبایل : {phoneNumber ? phoneNumber : ''}</li>
                  <li>تاریخ رزرو : {reserveData ? reserveData : ''}</li>
                  <li>شماره میز: {tableNumber ? tableNumber : ''}</li>
                </ul>
              </div>
            </div>
            <div className='row'>
              <div className='textarea'>
                <label htmlFor='foodName'>وضعیت :</label>
                <ul className='list'>
                  <li style={reserveStatus ? { color: '#198524' } : { color: '#fd3a50' }}>وضعیت : {reserveStatus ? 'بررسی شده' : 'بررسی نشده'}</li>
                </ul>
              </div>
            </div>
          </form>
          <div className='copyright'>
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
